import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';

export const OperatorListFragment = gql`
  fragment OperatorList on OperatorLookupResult {
    # This alias is only possible with { join_type: user_records }.
    # Under other join_types, user_id is nullable field.
    id: user_id
    name
    lookupStatus: lookup_status
  }
`;

export const GetAllOperatorsQuery = gql`
  query GetAllOperators {
    all_operators: lookup_operators(lookup_query: {join_type: user_records}) {
      edges {
        node {
          ...OperatorList
        }
      }
    }
  }
  ${OperatorListFragment}
`;

const marshallUserData = ({ ownProps, data }) => {
  const operatorList = querySelector(data, '$.all_operators.edges[*].node', []);
  return {
    ...ownProps,
    operatorList,
    data,
  };
};

const queryOperatorData = graphql(GetAllOperatorsQuery, {
  props: marshallUserData,
});

export const queryOperatorGQL = compose(
  queryOperatorData,
  queryMetaHandler,
  omitProps(['data']),
);

const UpdateOperatorMutation = gql`
  mutation UpdateOperator($input: OperatorUpdateInput!) {
    operator_update(input: $input) { id }
  }
`;

export const updateOperatorMutationGQL = (client, operator) => {
  const variables = {
    input: {
      id: operator.id,
      name: operator.name,
    },
  };

  const options = {
    mutation: UpdateOperatorMutation,
    variables,
    refetchQueries: [
      { query: GetAllOperatorsQuery },
    ],
  };
  return client.mutate(options);
};
